"use strict";
(function () {
  if (!customElements.get("sticky-atc-bar")) {
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.setStickyBarHeight = this.setStickyBarHeight.bind(this);
        this.toggleHeight = this.toggleHeight.bind(this);
        this.handleResize = this.handleResize.bind(this);
        
        this.parent = this.closest(".sticky-atc-bar");
        this.headerIconBtn = this.querySelector(".atc-bar-header-icon");
        this.select = this.querySelector(".atc-product-form .select");
        this.formContainer = this.querySelector(".atc-product-form");
        this.form = this.querySelector(".atc-product-form form");
        this.formBtn = this.querySelector(".button-add-card");
        this.openStickyBtn = this.querySelector(".atc-bar-product-top-button");
        this.submitBtn = this.querySelector(".product-form__submit");
        this.submitBtnText = this.querySelector(".product-form__submit span");
        this.closeStickyBtn = this.querySelector(".close-sticky");
        
        this.form.addEventListener('submit', () => {
          this.CloseStickyCard();
          this.changedStickyAfterAdded();
        });
        
        this.headerIconBtn.addEventListener("click", () => {
          this.parent.classList.remove('product-added');
          this.OpenStickyCard();
        });
      }

      connectedCallback() {
        this.setStickyBarHeight();
        this.attachClickHandler();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      handleResize() {
        if (this.parent && this.parent.classList.contains("open") && this.formContainer) {
          this.formContainer.style.height = 0;
          this.formContainer.style.height = this.formContainer.scrollHeight + "px";
        }
        this.setStickyBarHeight();
      }

      attachClickHandler() {
        if (this.openStickyBtn) {
          this.openStickyBtn.addEventListener("click", this.OpenStickyCard);
        }
        if (this.closeStickyBtn) {
          this.closeStickyBtn.addEventListener("click", this.CloseStickyCard);
        }
      }

      toggleHeight(element) {
        if (!element) return;
        
        if (element.style.height && element.style.height !== "0px") {
          element.style.height = "0px";
        } else {
          
          element.style.height = "auto";
          const actualHeight = element.scrollHeight;
          element.style.height = actualHeight + "px";
        }
      }

      changedStickyAfterAdded() {
        this.parent.classList.add('product-added');
      }

      OpenStickyCard = (event) => {
        if (!this.parent.classList.contains("open")) {
          this.parent.classList.add("open");
          this.toggleHeight(this.formContainer);
        }
      };

      CloseStickyCard = (event) => {
        this.parent.classList.remove("open");
        this.toggleHeight(this.formContainer);
      };

      setStickyBarHeight() {
        if (this.parent) {
          const height = this.parent.offsetHeight;
        }
      }
    }

    customElements.define("sticky-atc-bar", StickyAtcBar);

    function checkBarVisibility() {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      const productVisible = document.querySelector(".product .product__info-wrapper");
      
      if (stickyAtcBar && productVisible) {
        document.addEventListener("scroll", (e) => {
          let productVisibleHeight = productVisible.offsetHeight / 2;
          let scrolled = document.scrollingElement.scrollTop;
          
          if (scrolled > productVisibleHeight && !stickyAtcBar.classList.contains("js-hidden")) {
            stickyAtcBar.classList.add("atc-visible");
          } else {
            stickyAtcBar.classList.remove("atc-visible");
          }
        });
      }
    }

    document.addEventListener("DOMContentLoaded", checkBarVisibility);
    document.addEventListener("shopify:section:load", checkBarVisibility);
  }
})();